import React from 'react';
import { RegulationsDashboardMetrics } from './types';

interface Props {
  metrics: RegulationsDashboardMetrics | null;
  loading: boolean;
}

export const ComplianceMetricsDashboard: React.FC<Props> = ({ metrics }) => {
  return (
    <div className="stats-grid">
      <div className="stat-card">
        <span className="stat-label">Regulatory Coverage Rate</span>
        <span className="stat-value" style={{ color: '#2563eb' }}>%{metrics?.coverage_percentage ?? 0}</span>
        <span className="stat-sub">Applicable requirements mapped to internal controls</span>
      </div>

      <div className="stat-card">
        <span className="stat-label">Compliance Rate</span>
        <span className="stat-value" style={{ color: '#059669' }}>%{metrics?.compliance_rate_percentage ?? 0}</span>
        <span className="stat-sub">{metrics?.compliant_count ?? 0} / {metrics?.applicable_requirements ?? 0} Compliant</span>
      </div>

      <div className="stat-card">
        <span className="stat-label">High-Risk Compliance Gaps</span>
        <span className="stat-value" style={{ color: (metrics?.high_risk_gaps ?? 0) > 0 ? '#dc2626' : '#64748b' }}>
          {metrics?.high_risk_gaps ?? 0}
        </span>
        <span className="stat-sub">Critical / non-compliant gaps requiring immediate action</span>
      </div>

      <div className="stat-card">
        <span className="stat-label">Open Regulatory Changes</span>
        <span className="stat-value" style={{ color: '#d97706' }}>{metrics?.open_changes_count ?? 0}</span>
        <span className="stat-sub">{metrics?.pending_actions_count ?? 0} pending action packages</span>
      </div>
    </div>
  );
};
